


export const getInterPolateValue = (value, start1, end1,
    start2, end2, isClamped) =>{
  const n1 = (value - start1) * (end2 - start2);
  const n2 = (end1 - start1) + start2;
  const newvalue = n1 / n2;
  if (isClamped) {
    if (start2 < end2) {
      //same way
      if (newvalue <= start2) {
        return start2;
      }
      if (end2 <= newvalue) {
        return end2;
      }
    } else {
      //inverse mode
      if (newvalue <= end2) {
        return end2;
      }
      if (start2 <= newvalue) {
        return start2;
      }
    }
  }
  return newvalue;
}